import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute, useRouter } from '@tanstack/react-router';
import { useAuth } from '../../../features/auth/auth-context';
import { CityForm } from '../../../features/cities/components/city-form';
import { DeleteCityDialog } from '../../../features/cities/components/delete-city-dialog';
import { cityByIdOptions } from '../../../features/cities/queries';
import { CityBroadcastBlock } from '../../../features/city-broadcast/components/city-broadcast-block';
import { CityProvidersBlock } from '../../../features/payment-providers/components/city-providers-block';
import { PageHeader } from '../../../shared/components/page-header';

export const Route = createFileRoute('/_authenticated/cities/$cityId')({
  staticData: { breadcrumb: 'Редактирование' },
  loader: ({ context, params }) => context.queryClient.ensureQueryData(cityByIdOptions(params.cityId)),
  component: EditCityPage,
});

function EditCityPage() {
  const router = useRouter();
  const { cityId } = Route.useParams();
  const { data: city } = useSuspenseQuery(cityByIdOptions(cityId));
  const { adminRoles } = useAuth();
  const isSuperadmin = adminRoles.includes('SUPERADMIN');

  return (
    <div>
      <PageHeader
        title={city.name}
        description={`slug: ${city.slug}`}
        actions={
          <div className="flex gap-2">
            <DeleteCityDialog mode="soft" city={city} onDeleted={() => router.navigate({ to: '/cities' })} />
            {isSuperadmin && (
              <DeleteCityDialog
                mode="hard"
                city={city}
                onDeleted={() => router.navigate({ to: '/cities' })}
              />
            )}
          </div>
        }
      />
      <CityForm mode="edit" city={city} />
      <div className="mt-6">
        <CityProvidersBlock cityId={cityId} />
      </div>
      <div className="mt-6">
        <CityBroadcastBlock cityId={cityId} />
      </div>
    </div>
  );
}
